var OrderChangeMessaged = false;

// Change the order (but not the number) of the fields
function UpdateOrder(index)
{
	var iOrder = getElementsByClass('ScoreOrder');

	var newOrder = iOrder[index].value;

	if (newOrder > 0)
	{
		// Ensure newly entered order does not skip any
		var numValid = 0;
		for (i = 0; i < iOrder.length; i++)
		{
			if (iOrder[i].selectedIndex > 0)
			{
				numValid++;
			}
		}
		if (newOrder > numValid)
		{
			newOrder = numValid;
			iOrder[index].selectedIndex = newOrder;
		}
	}

	var old_order = iOrder[index].getAttribute('savedOrder');
	iOrder[index].setAttribute('savedOrder', iOrder[index].selectedIndex);

	var i;
	if (old_order == 0) // Making something visible
	{
		for (i = 0; i < iOrder.length; i++)
		{
			if ((i != index) && // skip the one we just moved
			(iOrder[i].selectedIndex >= newOrder))
			{
				// shift up one
				iOrder[i].selectedIndex++;
				iOrder[i].setAttribute('savedOrder', iOrder[i].selectedIndex);
			}
		}
	}
	else if (newOrder == 0) // Making something invisible
	{
		for (i = 0; i < iOrder.length; i++)
		{
			if ((i != index) && // skip the one we just moved
			(iOrder[i].selectedIndex > old_order)) // shift down one
			{
				iOrder[i].selectedIndex--;
				iOrder[i].setAttribute('savedOrder', iOrder[i].selectedIndex);
			}
		}
	}
	else if (old_order < newOrder) // Moving something up
	{
		for (i = 0; i < iOrder.length; i++)
		{
			if ((i != index) && // skip the one we just moved
			(iOrder[i].selectedIndex > old_order) && (iOrder[i].selectedIndex <= newOrder)) // shift up one
			{
				iOrder[i].selectedIndex--;
				iOrder[i].setAttribute('savedOrder', iOrder[i].selectedIndex);
			}
		}
	}
	else if (old_order > newOrder) // Moving something down
	{
		for (i = 0; i < iOrder.length; i++)
		{
			if ((i != index) && // skip the one we just moved
			(iOrder[i].selectedIndex < old_order) && (iOrder[i].selectedIndex >= newOrder)) // shift down one
			{
				iOrder[i].selectedIndex++;
				iOrder[i].setAttribute('savedOrder', iOrder[i].selectedIndex);
			}
		}
	}

	var LastElement = iOrder.length - 1;
	if (index == LastElement)
		CheckLastElement();	// special logic for last element
	else
		OrderChangedMessage();
}

// Called when page is saved
function CheckOrder()
{
	if (OrderChangeMessaged == false)
	{
		// Check the last display element.
		// If the user has changed either the name or the macro output, 
		// 		then ensure its order is the last one.
		// Note "Not Visible" will affect the order - those subscritps are '0'
		var Names = getElementsByClass('DisplayName');
		var MacroOutputs = getElementsByClass('ScoreMacroOutput');
		var LastElement = Names.length - 1;
		if ((Names[LastElement].value != '') || (MacroOutputs[LastElement].value != ''))
		{
			// Adding a new entry
			CheckLastElement();
		}
	}
}

// This logic allows the user to change the last element
//	as long as he doesn't change the Formula subscripts by reordering.
function CheckLastElement()
{
	var iOrder = getElementsByClass('ScoreOrder');

	var LastElement = iOrder.length - 1;
	if (LastElement < 1)
		return;
	var LastElementOrder = parseInt(iOrder[LastElement].value);

	for (var i = 0; i < LastElement; i++)
	{
		if (iOrder[i].value >= LastElementOrder)
		{
			OrderChangedMessage();
			return;
		}
	}
}

function OrderChangedMessage(DoConfirmation)
{
    DoConfirmation = !!DoConfirmation || false;
	if (OrderChangeMessaged === false)
	{
		var Msg = 'Warning: Changing the display order can affect your formula inputs and your changes may not get saved. Please verify your formula outputs again.';
		var TextElement = document.getElementById('FormulaText');
		var Text = TextElement.value.trim();
		if (Text.length > 0)
		{
			// There is a formula, so display the warning
			if (DoConfirmation)
			{
				Msg = 'Warning: Deleting a formula field or changing the display order can affect your formula inputs and your changes may not get saved.\n\n';
				Msg += 'Click cancel to verify your formula outputs again.';
				var ans = confirm(Msg);
				if (ans === false)
					return false;
			}
			else
			{
				alert(Msg);
			}

			OrderChangeMessaged = true;
		}
	}
	return true;
}

// User is deleting a Manual Score
function DeleteRec(Name, Id)
{
	var SaveChange = OrderChangedMessage(true);
	if (SaveChange)
	{
		var form = this.document.forms[0];
		var GetString = '?' + Name + '=' + Id;
		form.action += GetString;
		form.submit();
	}
}

function DeleteElement(parmName, Id)
{
	// var response = confirm ("Save Changes?");
	document.forms[0][parmName].value = Id;
	document.SSPConfigForm.submit();
}

function SSPScoreWarning(Element)
{
	// var Response = confirm('Warning: SSP Score results are for Research Use Only.  Not for use in diagnostic procedures');
	// if (Response == true)
	{
		CheckModified(Element);
		return true;
	}
	/**
	else
	{
		Element.value = Element.getAttribute('prevValue');
		Element.focus();
		return false;
	}
	**/
}


function SSPOverwrite(Element)
{
	// This is a <td> of our table's parent table.  This should get ID'd and search for.
	var AncestorCell = Element.parentNode.parentNode.parentNode.parentNode.parentNode;
	// var Response = confirm('Warning: Overrides for SSP Score results make them "Research Use Only", i.e. not for use in diagnostic procedures');
	// if (Response == true)
	{
		if (CheckModified(Element))
			AncestorCell.setAttribute ("Modified", "true");
		return true;
	}
	/***
	else
	{
		Element.value = Element.getAttribute('oldvalue');
		CheckModified(Element);	// Clear the modified color
		AncestorCell.removeAttribute ("Modified");
		Element.focus();
		return false;
	}
	****/
}

